import React from 'react'
import { shallow } from 'enzyme'
import { Pane } from '../Pane'
import business from './testData/business'
import { MockedProvider } from 'react-apollo/test-utils'
import years from './testData/years'
import interimPeriods from './testData/interimPeriods'

describe('<Pane />', () => {
  const noop = () => {}
  let wrapper, instance, props
  beforeEach(() => {
    props = {
      years,
      entity: business,
      resourceType: 'Business',
      loanId: 6252,
      refetch: noop,
      interimPeriods
    }
    // Wrap in a div because `Pane` returns a fragment
    wrapper = shallow(
      <div>
        <Pane {...props} />
      </div>
    )
    instance = wrapper.instance()
  })
  it('renders Pane', () => {
    expect(wrapper.find(Pane).exists()).toEqual(true)
    expect(wrapper.find('_Pane_').exists()).toEqual(false) // NOTE: Prevents false-positive I have encountered
  })

  it('renders no input', () => {
    expect(wrapper.find('input').exists()).toEqual(false)
  })
  describe('#onFormOptionsChange', () => {
    beforeEach(() => {
      wrapper = shallow(<Pane {...props} />)
      instance = wrapper.instance()
    })
    it('should update the component\'s years property with the new form name', () => {
      const updatedYear = 2016
      const newFormName = '1040C'
      instance.onFormOptionsChange(newFormName, updatedYear)
      expect(wrapper.state('years').get(updatedYear).taxReturn.formName).toBe(newFormName)
    })
    it('should update the component\'s years property with the period interim if the form option is changed to interim', () => {
      const updatedYear = 2017
      const newFormName = 'interim'
      instance.onFormOptionsChange(newFormName, updatedYear)
      expect(wrapper.state('years').get(updatedYear).period).toBe('interim')
    })
  })
  describe('#getDerivedStateFromProps', () => {
    beforeEach(() => {
      wrapper = shallow(<Pane
        years={years}
        entity={business}
        resourceType="Business"
        loanId={6252}
        refetch={jest.fn()}
        interimPeriods={interimPeriods}
      />)
      instance = wrapper.instance()
    })
    describe('when the entity changes', () => {
      let nextProps, prevState
      beforeEach(() => {
        nextProps = {
          entity: {
            ...business,
            rid: 1
          }
        }
        prevState = {
          entity: {
            rid: 2
          }
        }
      })
      it('should set isEditable to false', () => {
        const newState = Pane.getDerivedStateFromProps(nextProps, prevState)
        expect(newState.isEditable).toBeFalsy()
      })
      it('should recalculate yearSources', () => {
        const newState = Pane.getDerivedStateFromProps(nextProps, prevState)
        expect(newState.yearSources).toBeTruthy()
      })
      it('should set rid to the new entity\'s rid', () => {
        const newState = Pane.getDerivedStateFromProps(nextProps, prevState)
        expect(newState.rid).toBe(nextProps.entity.rid)
      })
    })
  })
})
